var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"role-ribbon"},[_c('PageContainer',[_c('div',{staticClass:"role-ribbon-content"},[_c('span',{staticClass:"role-label"},[_vm._v(_vm._s(_vm.label))]),_c('v-spacer'),(_vm.universityLogo)?_c('img',{staticClass:"university-logo",attrs:{"src":_vm.universityLogo}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }